import React from 'react';
import QuickCreateProjectModal from './QuickCreateProjectModal';

/**
 * QuickHireModal - Wrapper for single talent quick hire
 * Maintains backward compatibility with existing usage
 */
const QuickHireModal = ({talent, searchFilters = {}, onSuccess, onClose}) => {
    return (
        <QuickCreateProjectModal
            type="single-talent"
            data={talent}
            searchFilters={searchFilters}
            onSuccess={onSuccess}
            onClose={onClose}
        />
    );
};

export default QuickHireModal;
